import { rest } from 'msw';

export default [
  rest.post('/api/token/verifyZipCode', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        securityQuestions: [
          {
            key: 'FAVORITE_BEVERAGE',
            description: 'What is your favorite beverage?',
          },
          {
            key: 'FAVORITE_MOVIE',
            description: 'What is your favorite movie?',
          },
          {
            key: 'PET_NAME',
            description: "What is your favorite pet's name?",
          },
          {
            key: 'FAVORITE_TEACHER',
            description: 'What is the last name of your favorite teacher?',
          },
          {
            key: 'BEST_FRIEND',
            description: "What is your best friend's name?",
          },
          {
            key: 'SPORTS_TEAM',
            description: 'What is your favorite sports team?',
          },
          {
            key: 'HONEYMOON',
            description: 'Where did you go on your honeymoon?',
          },
          {
            key: 'NIECE_NEPHEW',
            description: 'What is the first name of your oldest niece/nephew?',
          },
          {
            key: 'FIRST_JOB',
            description:
              'What is the name of the first company you worked for?',
          },
          {
            key: 'FIRST_CAR',
            description: 'What was your first car (make and model)?',
          },
        ],
        validationToken: '123123123',
        emailAddress: 'xyz@yopmail.com',
      })
      // ctx.json({
      //   messages: [
      //     {
      //       code: 'INV_005',
      //       description: 'Invite Invalid',
      //       source: null,
      //       type: 'Failure',
      //     },
      //   ],
      // })
    );
  }),
];
